/**
 * Wingman MusicEngine
 * Manages the high-level 'Vibe' orchestration using the Spotify bridge.
 * Context-aware playlist selection based on active Mission Control protocol.
 */

const VIBE_MAP = {
    DEFAULT: "Spatial Chill Essentials",
    BOOTH: "Future Bass / Tech Show",
    LOBBY: "Luxury Penthouse Deep House",
    DRIVER: "Night Drive Neon / Focus",
    DEMO: "Orchestral Intelligence",
    ORACLE: "Ambient Reasoning"
};

let currentVibe = null;

export const MusicEngine = {
    /**
     * Set vibe based on Mode name
     */
    setVibeFromMode(modeName) {
        const upper = modeName.toUpperCase();
        const vibe = VIBE_MAP[upper] || VIBE_MAP.DEFAULT;
        
        if (vibe === currentVibe) return;
        
        currentVibe = vibe;
        console.info(`[MusicEngine] Switching vibe: ${vibe}`);
        
        // Mock Spotify Bridge Call
        this._mockSpotifyCall(vibe);
    },

    _mockSpotifyCall(playlistName) {
        if (typeof window === 'undefined') return;
        // In production, this targets the Spotify SDK or Personalization MCP gateway
        window.dispatchEvent(new CustomEvent("wingman:music:vibe_change", { 
            detail: { playlist: playlistName, timestamp: new Date() }
        }));
    },


    getCurrentVibe() {
        return currentVibe;
    }
};

if (typeof window !== 'undefined') {
    window.MusicEngine = MusicEngine;
}
